import template from './index.html.twig';
import './index.scss';

Shopware.Component.register(
    'sw-cms-preview-block-moorl-grid-layout-seventeen',
    {
        template,
    }
);
